import { convertStringToBigInt, convertBigIntToString } from '@/utils';
import ProcessConfig from './ProcessConfig';

export default class ProcessConfigAuthorization extends ProcessConfig {

    constructor(data: any) {
        super(data);
        this.type = convertStringToBigInt(data.authorizationType);
        this.filterMinimumValidType = BigInt(1);
    }

    public toServer() {
        return {
            id: this.id,
            authorizationType: convertBigIntToString(this.type),
            title: { ...this.title },
            active: this.active
        };
    }
}
